/* شريط تمرير جانبي ثابت تحت الشاشة للجداول العريضة.
   المشكلة: الجدول العريض (زي قسم التأشيرات 16 عمود) شريط التمرير بتاعه بيبقى في آخر الجدول تحت،
   فعلى لابتوب صغير لازم تنزل لآخر الصفحة عشان تتحرك يمين وشمال.
   الحل: لما يكون فيه جدول عريض ظاهر وشريطه الأصلي مش باين، بيظهر شريط تحت الشاشة متزامن معاه.
   شغال على كل الشاشات من غير تعديل فيها. */

const SELECTOR = '[class*="overflow-x-auto"],[class*="overflow-auto"],[class*="overflow-x-scroll"]';

export function initWideScroll() {
  if (typeof window === 'undefined' || window.__wideScroll) return;
  window.__wideScroll = true;

  const bar = document.createElement('div');
  bar.className = 'wide-scroll-bar';
  bar.setAttribute('aria-hidden', 'true');
  const inner = document.createElement('div');
  bar.appendChild(inner);
  document.body.appendChild(bar);

  let target = null;
  let syncing = false;
  let raf = 0;

  const hide = () => { if (bar.style.display !== 'none') bar.style.display = 'none'; if (target) target.removeEventListener('scroll', fromTarget); target = null; };

  function fromTarget() {
    if (syncing || !target) return;
    syncing = true; bar.scrollLeft = target.scrollLeft; requestAnimationFrame(() => { syncing = false; });
  }
  bar.addEventListener('scroll', () => {
    if (syncing || !target) return;
    syncing = true; target.scrollLeft = bar.scrollLeft; requestAnimationFrame(() => { syncing = false; });
  });

  function pick() {
    const vh = window.innerHeight;
    let best = null, bestArea = 0;
    for (const el of document.querySelectorAll(SELECTOR)) {
      if (el === bar || el.scrollWidth <= el.clientWidth + 8) continue;
      const cs = getComputedStyle(el);
      if (!/(auto|scroll)/.test(cs.overflowX)) continue;
      const r = el.getBoundingClientRect();
      if (r.width < 200 || r.bottom <= vh + 4 || r.top >= vh - 60 || r.bottom < 0) continue; // شريطه الأصلي باين أو الجدول مش ظاهر
      const visible = Math.min(r.bottom, vh) - Math.max(r.top, 0);
      const area = visible * r.width;
      if (area > bestArea) { best = el; bestArea = area; }
    }
    return best;
  }

  function update() {
    raf = 0;
    const el = pick();
    if (!el) return hide();
    if (el !== target) {
      if (target) target.removeEventListener('scroll', fromTarget);
      target = el;
      target.addEventListener('scroll', fromTarget, { passive: true });
    }
    const r = el.getBoundingClientRect();
    bar.style.display = 'block';
    bar.style.left = Math.max(0, r.left) + 'px';
    bar.style.width = Math.min(r.width, window.innerWidth - Math.max(0, r.left)) + 'px';
    bar.dir = getComputedStyle(el).direction;
    inner.style.width = el.scrollWidth + 'px';
    if (!syncing) { syncing = true; bar.scrollLeft = el.scrollLeft; requestAnimationFrame(() => { syncing = false; }); }
  }
  const schedule = () => { if (!raf) raf = requestAnimationFrame(update); };

  window.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  setInterval(schedule, 1500);
}
